import { useQuery } from '@tanstack/react-query';
import { brokersApi, type BrokerView } from '@/api/client';

/*
 * The brokers this account sees, from the server's one switch
 * (store.OpenBrokers / PreviewBrokers). Until it answers, Phemex alone: a
 * preview broker never flashes up for someone who may not see it.
 */
const FALLBACK: BrokerView[] = [{ id: 'phemex', name: 'Phemex', preview: false }];

export function useBrokers() {
  const q = useQuery({ queryKey: ['brokers'], queryFn: brokersApi.list, staleTime: 10 * 60_000 });
  const list = q.data?.brokers ?? FALLBACK;
  const find = (id: string) => list.find((b) => b.id === id.toLowerCase());
  return {
    list,
    visible: (id: string) => !!find(id),
    preview: (id: string) => !!find(id)?.preview,
  };
}
